import { useTranslation } from "react-i18next";
import { useState } from "react";
import styled from "styled-components";
import { PsiLogo } from "./icons/PsiLogo";
export const Logo = () => {
  const { t } = useTranslation();
  const [imgError, setImgError] = useState(false);
  
  const handleImageError = () => {
    setImgError(true);
  };

  return (
    <StyledLogo>
      <a href={"/"}>
        {imgError ? (
          <PsiLogo />
        ) : (
          <img 
            src={"./logo.svg"} 
            alt="logo" 
            onError={handleImageError}
          />
        )}
      </a>
      <a href={"/"}>
        <h5>{t("page.title")}</h5>
      </a>
    </StyledLogo>
  );
};

const StyledLogo = styled.div`
  display: flex;
  cursor: pointer;
  display: flex;
  align-items: center;
  column-gap: 10px;
  min-height: 38px;
  a {
    text-decoration: none;
    img {
      width: 33px;
    }
    .placeholder-logo {
      width: 33px;
      height: 33px;
      background-color: #f0f0f0;
      border: 2px solid #d9d9d9;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 10px;
      font-weight: bold;
      color: #666;
    }
    h5 {
      font-style: normal;
      font-weight: 600;
      font-size: 21.039px;
      line-height: 22px;
      color: ${(p) => p.theme.colors.text_secondary};
      margin: 0;
    }
  }
`;
